/**
 * Dynatrace RUM Integration Module
 *
 * Complete module for integrating Dynatrace Real User Monitoring
 * with support for user context, custom events, and data disappearance detection.
 */

// Core dynatrace functionality
export * from './dynatrace';
export * from './dynatrace-user-context';
export * from './dynatrace-custom-events';
export * from './dynatrace-csp';

// Types
export type {
	DynatraceRUMConfig,
	DynatracePrivacyConfig,
	DynatraceSessionReplayConfig,
	DynatraceCookieConsentConfig,
	DynatraceRUMAPI,
	ScreenLoadEventProperties,
	DataDisappearedEventProperties,
	UseDataDisappearanceDetectorOptions,
} from './types';
